import React from 'react';
import ribbon from '../../../../assets/icons/recommended-ribbon.svg';
import { Icon } from '../../../../wag-react/components/icon';
import { Typography } from '../../../../wag-react/components/Typography';
import { Span } from '../../../../wag-react/core-components/span';
import { Box } from '../../../../wag-react/next-components/box';
import { Flex, FlexProps } from '../../../../wag-react/next-components/Flex';
import { Image } from '../../../../wag-react/next-components/image';
import { theme } from '../../../../wag-react/themes/base-theme';
export type AnswerProps = {
  avatarUrl?: string;
  dateLabel: string;
  expertTitle: string;
  expertName: string;
  numRecommendations: number;
  recommendedText: string;
  text: string;
} & FlexProps;
export const Answer = ({
  avatarUrl,
  dateLabel,
  expertTitle,
  expertName,
  numRecommendations,
  recommendedText = 'Recommendations',
  text,
  ...rest
}: AnswerProps) => <Flex alignItems="center" flexDirection="column" bg={theme.colors.whiteSmoke} borderRadius={[0, '12px']} px={['16px', '24px']} pb={['16px', '24px']} {...rest} data-sentry-element="Flex" data-sentry-component="Answer" data-sentry-source-file="index.tsx">
    <Box mt="-10px" width="50px" height="25px" bg={theme.colors.whiteSmoke} style={{
    clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
    WebkitClipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)'
  }} data-sentry-element="Box" data-sentry-source-file="index.tsx" />

    <Flex alignItems="center" width={1} pt={['16px', '24px']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      {avatarUrl && <Image src={avatarUrl} height="54px" width="54px" borderRadius="30px" alt="Expert avatar" />}

      <Box pl={avatarUrl ? '10px' : 0} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Typography color={theme.colors.dimGray} fontFamily="muliBold" m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {expertName}

          <Span color={theme.colors.darkGray} data-sentry-element="Span" data-sentry-source-file="index.tsx">
            {` - ${expertTitle}`}
          </Span>
        </Typography>
        <Flex alignItems="center" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Icon src={ribbon} height="30px" width="30px" alt="Recommendation ribbon" data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
          <Typography fontFamily="muliBold" fontSize="16px" m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            {`${numRecommendations} ${recommendedText}`}
          </Typography>
        </Flex>
      </Box>
    </Flex>

    <Box width={1} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {text}
      </Typography>
      <Typography color={theme.colors.darkGray} fontSize="14px" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {dateLabel}
      </Typography>
    </Box>
  </Flex>;